import * as React from 'react';
import FormattedMessage from 'I18n/components/FormattedMessage';
import ValidationLabelIcon from 'flow-doctor-lib/components/diagnosis/non-enrollment/validation/ValidationLabelIcon';
import UIFlex from 'UIComponents/layout/UIFlex';
import { Text } from 'foundations-components/components/Text';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const EnrollmentCheckValidationResultLabel = ({
  validationResult,
  flowRevision
}) => {
  const validationCheckLabel = (() => {
    switch (validationResult.validationType) {
      case 'ENROLLMENT_LIST_EVALUATION':
        {
          return /*#__PURE__*/_jsx(Text, {
            as: "h5",
            marginInlineStart: "200",
            marginBlockEnd: "400",
            children: /*#__PURE__*/_jsx(FormattedMessage, {
              message: validationResult.enrollmentAllowed ? 'flow-doctor-lib.flows.diagnosticWizard.nonEnrollment.diagnosis.validationResults.ENROLLMENT_LIST_EVALUATION.label.passed' : validationResult.listId ? 'flow-doctor-lib.flows.diagnosticWizard.nonEnrollment.diagnosis.validationResults.ENROLLMENT_LIST_EVALUATION.label.failed.doesNotMeetCriteria' : 'flow-doctor-lib.flows.diagnosticWizard.nonEnrollment.diagnosis.validationResults.ENROLLMENT_LIST_EVALUATION.label.failed.noEnrollmentList'
            })
          });
        }
      case 'REFINEMENT_LIST_EVALUATION':
        {
          const hasRefinementList = flowRevision.flow.associatedLists.some(list => list.listTypes.includes('REFINE_BY_LIST'));
          return /*#__PURE__*/_jsx(Text, {
            as: "h5",
            marginInlineStart: "200",
            marginBlockEnd: "400",
            children: /*#__PURE__*/_jsx(FormattedMessage, {
              message: validationResult.enrollmentAllowed ? hasRefinementList ? 'flow-doctor-lib.flows.diagnosticWizard.nonEnrollment.diagnosis.validationResults.REFINEMENT_LIST_EVALUATION.label.passed.metRefinementCriteria' : 'flow-doctor-lib.flows.diagnosticWizard.nonEnrollment.diagnosis.validationResults.REFINEMENT_LIST_EVALUATION.label.passed.noRefinementCriteria' : 'flow-doctor-lib.flows.diagnosticWizard.nonEnrollment.diagnosis.validationResults.REFINEMENT_LIST_EVALUATION.label.failed'
            })
          });
        }
      case 'SUPPRESSION_LIST_EVALUATION':
        {
          const {
            isClassicWorkflow
          } = flowRevision.flow;
          const numSuppressionLists = Object.keys(validationResult.evaluationResultsByListId).length;
          return /*#__PURE__*/_jsx(Text, {
            as: "h5",
            marginInlineStart: "200",
            marginBlockEnd: "400",
            children: /*#__PURE__*/_jsx(FormattedMessage, {
              message: validationResult.enrollmentAllowed ? isClassicWorkflow ? numSuppressionLists > 0 ? 'flow-doctor-lib.flows.diagnosticWizard.nonEnrollment.diagnosis.validationResults.SUPPRESSION_LIST_EVALUATION.label.passed.notInSuppressionList' : 'flow-doctor-lib.flows.diagnosticWizard.nonEnrollment.diagnosis.validationResults.SUPPRESSION_LIST_EVALUATION.label.passed.noSuppressionLists' : numSuppressionLists > 0 ? 'flow-doctor-lib.flows.diagnosticWizard.nonEnrollment.diagnosis.validationResults.SUPPRESSION_LIST_EVALUATION.label.passed.doesNotMeetCriteria' : 'flow-doctor-lib.flows.diagnosticWizard.nonEnrollment.diagnosis.validationResults.SUPPRESSION_LIST_EVALUATION.label.passed.noSuppressionCriteria' : isClassicWorkflow ? 'flow-doctor-lib.flows.diagnosticWizard.nonEnrollment.diagnosis.validationResults.SUPPRESSION_LIST_EVALUATION.label.failed.inSuppressionList' : 'flow-doctor-lib.flows.diagnosticWizard.nonEnrollment.diagnosis.validationResults.SUPPRESSION_LIST_EVALUATION.label.failed.meetsCriteria'
            })
          });
        }
      case 'CLASSIC_GOAL_LIST_EVALUATION':
        {
          const hasGoalList = flowRevision.flow.associatedLists.some(list => list.listTypes.includes('CLASSIC_GOAL_LIST'));
          return /*#__PURE__*/_jsx(Text, {
            as: "h5",
            marginInlineStart: "200",
            marginBlockEnd: "400",
            children: /*#__PURE__*/_jsx(FormattedMessage, {
              message: validationResult.enrollmentAllowed ? hasGoalList ? 'flow-doctor-lib.flows.diagnosticWizard.nonEnrollment.diagnosis.validationResults.CLASSIC_GOAL_LIST_EVALUATION.label.passed.doesNotMeetCriteria' : 'flow-doctor-lib.flows.diagnosticWizard.nonEnrollment.diagnosis.validationResults.CLASSIC_GOAL_LIST_EVALUATION.label.passed.noGoalCriteria' : 'flow-doctor-lib.flows.diagnosticWizard.nonEnrollment.diagnosis.validationResults.CLASSIC_GOAL_LIST_EVALUATION.label.failed'
            })
          });
        }
      case 'FLOW_ENROLLMENT_MERGE_ALLOWED':
        {
          return /*#__PURE__*/_jsx(Text, {
            as: "h5",
            marginInlineStart: "200",
            marginBlockEnd: "400",
            children: /*#__PURE__*/_jsx(FormattedMessage, {
              message: validationResult.enrollmentAllowed ? 'flow-doctor-lib.flows.diagnosticWizard.nonEnrollment.diagnosis.validationResults.FLOW_ENROLLMENT_MERGE_ALLOWED.label.passed' : 'flow-doctor-lib.flows.diagnosticWizard.nonEnrollment.diagnosis.validationResults.FLOW_ENROLLMENT_MERGE_ALLOWED.label.failed'
            })
          });
        }
      default:
        return /*#__PURE__*/_jsx(Text, {
          as: "h5",
          marginInlineStart: "200",
          marginBlockEnd: "400",
          children: /*#__PURE__*/_jsx(FormattedMessage, {
            message: validationResult.enrollmentAllowed ? `flow-doctor-lib.flows.diagnosticWizard.nonEnrollment.diagnosis.validationResults.${validationResult.validationType}.label.passed` : `flow-doctor-lib.flows.diagnosticWizard.nonEnrollment.diagnosis.validationResults.${validationResult.validationType}.label.failed`
          })
        });
    }
  })();
  return /*#__PURE__*/_jsxs(UIFlex, {
    children: [/*#__PURE__*/_jsx(ValidationLabelIcon, {
      status: validationResult.enrollmentAllowed ? 'PASSED' : 'FAILED'
    }), /*#__PURE__*/_jsx("div", {
      style: {
        display: 'inline-block',
        position: 'relative',
        top: 2
      },
      children: validationCheckLabel
    })]
  });
};
export default EnrollmentCheckValidationResultLabel;